import { useTranslations } from '@npco/common-utils-translations'
import { EducationPanel } from '@npco/zeller-design-system'

import TERMINAL_PATH from 'assets/images/terminal-empty.png'
import { EXTERNAL_SHOP_URL } from 'const/externalLinks'
import {
  Coupon,
  Image,
} from 'pages/Devices/DevicesEmptyState/DevicesEmptyState.styled'

import { translations } from './DevicesEmptyState.i18n'

export const DevicesEmptyState = () => {
  const t = useTranslations(translations)

  return (
    <EducationPanel
      data-testid="terminals-empty-state"
      image={<Image src={TERMINAL_PATH} alt={t('imageAlt')} />}
      title={t('title')}
      description={t('description')}
      items={[t('item1'), t('item2'), t('item3')]}
      ctaDescription={t('ctaDescription', {
        code: <Coupon>{t('couponCode')}</Coupon>,
      })}
      ctaPrimary={{
        text: t('ctaPrimary'),
        onClick: () =>
          window.open(EXTERNAL_SHOP_URL, '_blank', 'noopener,noreferrer'),
      }}
    />
  )
}
